import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';
import { isApolloError } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop';
import { getStatusCode } from '@confluence/error-boundary/entry-points/isStatusCodeError';

export const shouldMarkErrorAsHandled = (
	error: ApolloErrorInterop | Error | undefined,
): boolean => {
	if (!error) return true;
	const statusCode = isApolloError(error)
		? getStatusCode(error?.graphQLErrors?.[0])
		: getStatusCode(error);
	if (!statusCode) return true;
	return !!(parseInt(statusCode) >= 400 && parseInt(statusCode) < 500);
};
